import { CardContent, CardTitle } from "src/MarketDataComponents/Card";
import { changeClassnameText, changeClassnameIcon } from "src/MarketDataComponents/Helpers";
import { FUND, ETF } from 'src/Api';

export default function Disclaimer({quote, handlers}) {
	
    const renderPriceInfo = () => {
        const changeNum = quote.dayChange ? parseFloat(quote.dayChange.replace(/[^0-9\.\-]/g, '')) : 0;
		const chngTextClassname = changeClassnameText(changeNum);
        const chngIconClassname = changeClassnameIcon(changeNum);
        const dayChangeEscaped = quote.dayChange ? quote.dayChange.replace('-','') : '0';

        return <>
            {quote.__typename === FUND ? <>
                {quote.lastPrice !== undefined && <>
                    <span className="ajb-inline-block" data-testid="price">
                        Price: <b data-testid="priceValue">{quote.lastPrice}</b>
                    </span>
                    <span className="ajb-divider font-weight-200 grey-300-text">|</span>
                </>}
            </> : <>
                {quote.bidPrice !== undefined && <>
                    <span className="ajb-inline-block" data-testid="sell">
                        Sell: <b data-testid="sellValue" id="quoteSellValue">{quote.bidPrice}</b>
						<span className="ajb-divider font-weight-200 grey-300-text">|</span>
                    </span>
                </>}
                
                {quote.askPrice !== undefined && <>
                    <span className="ajb-inline-block" data-testid="buy">
                        Buy: <b data-testid="buyValue" id="quoteBuyValue">{quote.askPrice}</b>
						<span className="ajb-divider font-weight-200 grey-300-text">|</span>
                    </span> 
                </>}
            </>}
        	
            <span className="ajb-inline-block" data-testid="changePercentage">
                Change: 
				<span id="changeContainer" data-testid="changePercentageValue">
					<b className={chngTextClassname}> {
						changeNum !== 0 && <i className={chngIconClassname}/>} <span id="quoteChangeValues">{dayChangeEscaped} ({quote.dayChangePct}%)</span>
					</b>
				</span>
            </span>
        </>
    }

	const getName = () => {		
		if (quote.__typename !== ETF && quote.__typename !== FUND && quote.nameShort) {
			return quote.nameShort + (quote.symbol ? ` (${quote.symbol})` : '');
		} else if (quote.__typename === ETF) {
			return quote.name + (quote.symbol ? ` (${quote.symbol})` : '');
		} else {
			return quote.name;
		}
	}

    const render = () => {
		const subheading = (quote.additionalName !== undefined ? quote.additionalName : undefined);
		// remove minus symbol from monetary value; we are using the chevron icon instead
		const activeButtons = [];
		// determine if buttons need to be rendered
		if (!handlers.buyOnClick || handlers.sellOnClick || handlers.regularOnClick ) {
			// at least one button is present
			const buttonClassnames = "c-btn button-default waves-effect waves-light button full-width margin-bottom-20";
			if (handlers.buyOnClick) {
				activeButtons.push(<CardContent key="buy-button"><button onClick={handlers.buyOnClick} title={`Buy ${quote.nameShort} shares`} type="button" className={`${buttonClassnames} button--confirmation-system-primary`} data-instruction="B" data-marketcode={quote.marketCode} data-testid="buyButton">Buy</button></CardContent>);
			}
			if (handlers.sellOnClick) {
				activeButtons.push(<CardContent key="sell-button"><button onClick={handlers.sellOnClick} title={`Sell ${quote.nameShort} shares`} type="button" className={`${buttonClassnames} button--negative-system-primary`} data-instruction="S" data-marketcode={quote.marketCode} data-testid="sellButton">Sell</button></CardContent>);
			}
			if (handlers.regularOnClick) {
				activeButtons.push(<CardContent key="regular-button"><button onClick={handlers.regularOnClick} title="Make a regular investment" type="button" className={`${buttonClassnames} button--positive-system-primary`} data-instruction="R" data-marketcode={quote.marketCode} data-testid="regularButton">Regular</button></CardContent>);
			}
			
			// fill in the remaining empty columns to ensure the grid is the correct size no matter how many buttons are rendered
			// this also ensures the grid is filled from the left
		
            for (let i = activeButtons.length; i < 3; i++) {
				activeButtons.push(<CardContent key={`spacer-${i}`}></CardContent>);
			}
		}

		return (
			<div className="ajb-grid-row">
				<div className="ajb-card padding-10-sm">
					{/* Display name of instrument */}
					<div className="ajb-grid">
						<CardTitle size="l" classnames="margin-bottom-0">
							<h1 className="h2 margin-bottom-0" data-testid="instrumentNameHeader">
								<span className="font-weight-bold">{getName()}</span>
							</h1>
							{/* Display subheading if present */}
							{subheading !== undefined &&
							<CardTitle size="m" classnames="margin-bottom-0">
								{subheading}
							</CardTitle>
							}
						</CardTitle>
					</div>
					{/* Prices and change */}
					<CardTitle size="m" classnames="margin-bottom-20 margin-top-20">
						{renderPriceInfo()}				
					</CardTitle>

					{/* Buttons */}
					{activeButtons.length > 0 && <div className="ajb-grid-cols">
						{activeButtons}
					</div>
					}
				</div>
			</div>
		);
	};

    return render();
}
